import { render, staticRenderFns } from "./StoreBody.vue?vue&type=template&id=2fd4d050&scoped=true&"
import script from "./StoreBody.vue?vue&type=script&lang=js&"
export * from "./StoreBody.vue?vue&type=script&lang=js&"
import style0 from "./StoreBody.vue?vue&type=style&index=0&id=2fd4d050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4d050",
  null
  
)

export default component.exports